<template>
  <div class="ModalCancel">
    <h4>Cancel this application?</h4>

    <p>
      Are you sure you want to cancel this application? All details you have entered will be deleted, and you cannot undo this action.
    </p>   
    <div class="buttons">
      <b-button variant="primary" id="btn-cancel-application" @click="cancelApplication">Cancel application</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCancel',
  computed: {
    modalOptions() {
      return this.$store.state.modal
    }
  },
  methods: {
    cancelApplication() {
      this.$store
        .dispatch('cancelApplication')
        .then(() => {

          if (this.modalOptions.logout) {
            this.$store.dispatch('logout')
            /* eslint-disable */
            // set cancelled application for CancelView
            if (this.modalOptions.application && !this.$store.state.application) {
              this.$store.dispatch('set', ['application', this.modalOptions.application])
            }
            /* eslint-enable  */
            this.$router.history.push('/cancel')
          } else if (this.modalOptions.onCancelCallback) {
            this.modalOptions.onCancelCallback()
          }
          this.$store.dispatch('closeModal')
        })
        .catch(() => {
          this.$store.dispatch('closeModal')
          this.$store.dispatch('set', [
            'error',
            new Error('Error when cancelling: Could not reach server')
          ])
          this.$router.history.push('/error')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.ModalCancel {
  padding: 1rem 2rem;
  h4 {
    margin-bottom: 2rem;
    color: $color-primary;
    font-weight: bold;
    font-size: 22px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;

    .btn {
      margin: 1rem 0 0;
      border: none;
      border-radius: 0.25rem;
      font-size: 1.6rem;
      background-color: $color-red;
    }
  }
}
</style>
